import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import EventIcon from "@mui/icons-material/Event";
import LocationOnOutlined from "@mui/icons-material/LocationOnOutlined";
import { Tooltip } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Flex from "../../../../../../components/Flex";
import Text from "../../../../../../components/Text";
import { formatDate } from "../../../../../../utils/date-time-utility";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import {
  DEFAULT_USER_SRC,
  getAddressFormat,
  getValueFromObj,
} from "../../../../../../utils/utils";
import RenderWithTooltip from "../../../../../../components/RenderWithTooltip";

const CommonBillDetails = ({ data }: { data: any[] }) => (
  <Flex
    gap={2}
    flexDirection={"row"}
    flexWrap={"wrap"}
    alignItems={"center"}
    sx={{ minWidth: 0, flex: "1 1 auto" }}
  >
    {data?.map((item) => (
      <Flex
        key={item.label}
        gap={1}
        alignItems={"center"}
        fontSize={"18px"}
        sx={{ minWidth: 0, maxWidth: "100%" }}
      >
        {item.icon}
        {item?.label?.length >= item?.trimmed ? (
          <Text
            sx={{
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            <Tooltip title={item?.label ?? ""} placement="top">
              {(item?.label?.slice(0, item.trimmed) + "...") as any}
            </Tooltip>
          </Text>
        ) : (
          <Text
            sx={{
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {!!item.label && item.label !== "" ? item.label : "-"}
          </Text>
        )}
      </Flex>
    ))}
  </Flex>
);

const ClaimsHeader = ({
  patientsData,
  title,
  onBack,
}: {
  patientsData?: any;
  title?: string;
  onBack?: () => void;
}) => {
  const navigate = useNavigate();

  return (
    <Flex
      gap={2}
      flexWrap={"wrap"}
      flexDirection={"row"}
      alignItems={"center"}
      px={0.5}
      width={"100%"}
    >
      <Flex
        gap={2}
        flexDirection={"row"}
        alignItems={"center"}
        sx={{ flexShrink: 0 }}
      >
        <ArrowBackIcon
          color="primary"
          sx={{ cursor: "pointer" }}
          fontSize="medium"
          onClick={() => {
            if (onBack) onBack();
            else navigate(-1);
          }}
        />
        <Text fontWeight={"bold"} variant="h6" fontSize={"20px"}>
          {title ?? "Claim Details"}
        </Text>
      </Flex>

      <Flex
        gap={1}
        flexDirection={"row"}
        alignItems={"center"}
        sx={{ color: "primary.main", flexShrink: 0, minWidth: 0 }}
      >
        <img
          src={patientsData?.avatar ?? DEFAULT_USER_SRC}
          alt=""
          width={"24px"}
          style={{ borderRadius: "50%" }}
        />
        <Text
          fontWeight={"bold"}
          variant="h6"
          fontSize={"20px"}
          ml={1}
          sx={{
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          {patientsData?.firstName} {patientsData?.lastName}
          {patientsData?.ecarehealthPatientId &&
            `(${patientsData?.ecarehealthPatientId})`}
        </Text>
      </Flex>

      <CommonBillDetails
        data={[
          {
            icon: <EventIcon color="primary" />,
            label: patientsData?.birthDate
              ? `${formatDate(patientsData.birthDate) ?? ""} ${
                  patientsData.age
                    ? `(${patientsData?.age?.toString()}  Yrs)`
                    : ""
                } (${patientsData.gender?.slice(0, 1)})`
              : "-",
          },
          {
            icon: <PersonOutlineIcon color="primary" />,
            label: (
              <RenderWithTooltip
                value={getValueFromObj(patientsData?.providerId)}
              />
            ),
          },
          {
            icon: <LocationOnOutlined color="primary" />,
            label: (
              <RenderWithTooltip
                value={getAddressFormat(patientsData?.address)}
              />
            ),
          },
        ]}
      />
    </Flex>
  );
};

export default ClaimsHeader;
